// extracted by mini-css-extract-plugin
module.exports = {"body":"AddStablePopout_body__2wrCu"};